import firebase from "firebase/compat/app";
import "firebase/compat/functions";

const getFunctions = () => firebase.app().functions("us-central1");

/**
 * Platform-admin only: set organizations/{orgId}.countryCode.
 */
export async function setInstitutionCountry({ orgId, countryCode = null }) {
  const callable = getFunctions().httpsCallable("setInstitutionCountry");
  const result = await callable({
    orgId,
    countryCode,
  });
  return result.data;
}
